import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  paddingLeft: "20px",
  paddingRight: "10px",
  paddingTop: "10px",
  paddingBottom: "10px",
  borderRadius: "10px",
  backgroundColor: theme.customColors.backgroundPrimary,
  border: `1px solid ${theme.customColors.textPrimary}`,
  boxShadow: "25px 25px 33px rgba(0, 0, 0, 0.25)"
}));
